import { transform } from "ol/proj";
import { setGoToYandexMirrorsButtonIsClicked } from "../../../../../stateManagement/reducers";
import { store } from "../../../../../stateManagement/store";
import { Feature, Map } from "ol";
import { goToYandexMirrorsMarkerStyle } from "../../styles/mapStyles";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Point } from "ol/geom";
import { getItemWebStorage } from "../../../../../features/webStorageSaver";

export function moveMarkerGoToYandexMirrors(event: any, markerFeature: any) {
    const coordinates = event.coordinate;
    const geometry = new Point(coordinates);
    markerFeature.setGeometry(geometry);
}

export function goToYandexMirrors(event: any, markerSource: any) {
    const mapZoom = getItemWebStorage('mapPosition')?.zoom
    const [longitude, latitude] = transform(event.coordinate, 'EPSG:3857', 'EPSG:4326');
    const url = `https://yandex.ru/maps/?l=mrc&ll=${longitude}%2C${latitude}&z=${mapZoom}`
    window.open(url, '_blank', 'noopener,noreferrer');
    store.dispatch(setGoToYandexMirrorsButtonIsClicked(false))
    markerSource.clear();
}

// Функция копирования координат в точке на карте
export function activateGoToYandexMirrors(isGoToYandexMirrorsButtonClicked: boolean, map?: Map) {
    const markerFeature = new Feature();
    markerFeature.setStyle(goToYandexMirrorsMarkerStyle);
    const markerSource = new VectorSource({
        features: [markerFeature],
    });
    const markerLayer = new VectorLayer({
        zIndex: 6000,
        source: markerSource,
    });
    const newMarkerFunction: any = (event: any) => goToYandexMirrors(event, markerSource)
    const newMoveMarkerFunction: any = (event: any) => moveMarkerGoToYandexMirrors(event, markerFeature)
    // Вешаем на карту слушатель нажатия для копирования
    if (isGoToYandexMirrorsButtonClicked) {
        map?.addLayer(markerLayer)
        map?.on('pointermove', newMoveMarkerFunction);
        map?.on('singleclick', newMarkerFunction)
    }
    return {
        off: () => {
            map?.removeLayer(markerLayer);
            map?.un('pointermove', newMoveMarkerFunction);
            map?.un('singleclick', newMarkerFunction);
        }
    }
}